import React, { useState } from "react";
import svgData from "../../constants/utilities/svgData";
import { validateInputSecurity } from "../../constants/helpers/helperFunctions";
import toast from "react-hot-toast";

export default function SearchBox({ onChange, placeholder = "Search" }) {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleChange = (e) => {
    const val = e.target.value;
    const errorMsg = validateInputSecurity(val);
    if (errorMsg) {
      toast.error(errorMsg);
      return;
    }
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="searchBox" style={{ position: "relative" }}>
      <input
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        className="comman-box-shadow"
        onFocus={() => setShowTooltip(true)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onBlur={() => setShowTooltip(false)}
      />
      {svgData?.searchIcon}

      {showTooltip && <div className="custom-tooltip">{placeholder}</div>}
    </div>
  );
}
